import type { VoidFunctionComponent } from 'react';
import Icon, { icons } from '../../../generic/Icon';
import Link from '../../../generic/Link';
import ListRowDetailsSeparator from '../../../generic/List/ListRowDetailsSeparator';
import sharedStyles from '../IssueDetails.module.less';
import styles from './IssueDetailsProjectsTable.module.less';

type Props = {
  url: string;
};

/**
 * IssueDetailsProjectTableManualTicketLink displays a link to
 * the manually linked ticket associated with a given project issue.
 */
const IssueDetailsProjectTableManualTicketLink: VoidFunctionComponent<Props> = ({ url }) => (
  <>
    <ListRowDetailsSeparator />
    <Link
      to={url}
      className={`${sharedStyles.projectStatus} ${styles.ticketLink}`}
      openInNewTab
    >
      <span className={`${sharedStyles.icon} ${sharedStyles.ticketedIcon}`}>
        <Icon icon={icons.ticket} />
      </span>
      Manually Ticketed
      <span className={`${sharedStyles.icon} ${styles.ticketLinkIcon}`}>
        <Icon icon={icons.externalLink} />
      </span>
    </Link>
  </>
);

export default IssueDetailsProjectTableManualTicketLink;
